(ns kyber.styles.shadows)

(def shadows {:shadow-6 "0px 2px 6px 0px rgba(0,0,0,0.2)"
              :shadow-12 "0px 4px 12px 0px rgba(0,0,0,0.2)"
              :shadow-24 "0px 8px 24px 0px rgba(0,0,0,0.2)"})
